import styled from 'styled-components';

// Styled components with existing class names
export const TabsContainer = styled.div.attrs({
    role: 'tablist',
    className:
        'dx-tabs dx-widget dx-visibility-change-handler dx-collection dx-tabs-expanded',
})``;

export const TabsWrapper = styled.div.attrs({
    className: 'dx-tabs-wrapper',
})``;

export const TabItem = styled.div.attrs((props) => ({
    className: `dx-item dx-tab${props.$isSelected ? ' dx-tab-selected' : ''} ${props.$isFocused ? ' dx-state-focused' : ''}`,
    role: 'tab',
    'aria-selected': props.$isSelected,
}))``;

export const TabContent = styled.div.attrs({
    className: 'dx-item-content dx-tab-content',
})``;

export const TabText = styled.span.attrs({
    className: 'dx-tab-text',
})``;